// extracted by mini-css-extract-plugin
module.exports = {"container":"WebistePayment_container__17FoT","logo":"WebistePayment_logo__1vMQ8","continuePrimary":"WebistePayment_continuePrimary__OC4qK"};